<template>
  <div class="formulate-input">
    <label v-if="label" class="formulate-input-label">{{ label }}</label>
    <UsersSelectPaginated
      :value="selectedValue"
      :multiple="false"
      :placeholder="$t('custom_forms.select_user')"
      :disabled="disabled"
      @input="onValueChanged"
    />
  </div>
</template>

<script>
import UsersSelectPaginated from "@/components/UsersSelectPaginated.vue";

export default {
  name: "UserPickerInput",
  components: {
    UsersSelectPaginated,
  },
  props: {
    value: {
      type: [Object, Number, String, null],
      default: null,
    },
    name: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      default: null,
    },
    onUpdateValue: {
      type: Function,
      default: null,
    },
  },
  computed: {
    selectedValue() {
      if (this.context && this.context.model !== undefined) return this.context.model;
      return this.value;
    },
  },
  methods: {
    onValueChanged(nextValue) {
      if (this.onUpdateValue) {
        this.onUpdateValue(nextValue || null);
      }
      if (this.context) {
        this.context.model = nextValue || null;
      }
      this.$emit("input", nextValue || null);
    },
  },
};
</script>
